import Vue from 'vue'
import VeeValidate from 'vee-validate'
import { Validator } from 'vee-validate'
import en from 'vee-validate/dist/locale/en'
import es from 'vee-validate/dist/locale/es'

import i18n from '@/plugins/i18n';
import enLocale from '@/locales/en.json'
import esLocale from '@/locales/es-MX.json'
en.attributes = enLocale
es.attributes = esLocale

Validator.extend('destPhoneValidation', {
  getMessage: () => 'The value is invalid.',

  validate: (value, args) => {
    let chars = ['(', ')', '-', ' ', ' ', '+', ' ']
    let num = args[0]
    chars.forEach((val) => {
      num = num.replace(val, '')
    })
    return num.length === 10
  }
});

Vue.use(VeeValidate, {
  i18nRootKey: 'validations', // customize the root path for validation messages.
  i18n,
  dictionary: {
    en,
    'es-MX': es
  }
})
